import { useEffect } from "react";
import { Col, Row, Badge } from "react-bootstrap";
import { useSelector } from "react-redux";

import defaultAvatar from "../../../assets/images/cpf.png";
import { SOCKET_CLIENT } from "../../../constants/socket";
import SocketClient from "../../../services/SocketClient";
import { isEmpty } from "../../../utils/string";
import {
  useQueryCurrentUser,
  useQueryMemberNotifications,
} from "../../../graphql/apollo/query-hooks";

const ChatRoom = ({ room }) => {
  const chat = useSelector((state) => state.chat);
  const { currentChat } = chat;
  const { currentUser } = useQueryCurrentUser();

  const isSuperAdmin = currentUser?.isSuperAdmin;
  const showBranch = isSuperAdmin && room.branch;

  const avatar = room?.member?.profileImage ?? defaultAvatar;
  const active = currentChat?.memberId === room?.member?.id;

  const { memberChatNotifications, refetch } = useQueryMemberNotifications({
    memberId: room?.member?.id,
    toAdmin: true,
  });

  useEffect(() => {
    refetch();
  }, [currentChat, refetch]);

  useEffect(() => {
    SocketClient.on(SOCKET_CLIENT.RECIEVE_CHAT_NOTIFICATION, (data) => {
      if (currentUser?.branch) {
        if (currentUser?.branch.id == data?.branch?.id) {
          refetch();
        }
      } else {
        if (data?.branch == undefined) {
          refetch();
        }
      }
    });
  }, [refetch]);

  const notiLength = memberChatNotifications?.length ?? 0;

  const emptyLastMessage = isEmpty(room?.lastMessage);
  const lastMessage = emptyLastMessage
    ? ""
    : room?.lastMessage.length <= 20
    ? room?.lastMessage
    : `${room?.lastMessage.substring(0, 20)}...`;

  return (
    <Row>
      <Col xs="3">
        <div className="avatar">
          <img src={avatar} alt="avatar" />
        </div>
      </Col>
      <Col xs="7">
        <div className={active && "active"}>
          <h5>
            {room?.member?.nickname}
            {`(${room?.member?.memberId})`}
            {showBranch && (
              <Badge pill bg="info">
                {room.branch.name}
              </Badge>
            )}
          </h5>
          <span>{lastMessage}</span>
        </div>
      </Col>
      <Col md="1">
        {notiLength > 0 && (
          <h4 className="m-2">
            <Badge si pill bg="success">
              {notiLength}
            </Badge>
          </h4>
        )}
      </Col>
    </Row>
  );
};

export default ChatRoom;
